// in src/Dashboard.js
import React, { useState, useEffect } from 'react';




import Grid from '@mui/material/Grid';
import Box from '@material-ui/core/Box';



import { AddMemberHeader } from './../components/AddMemberHeader';


import { useRefresh, useDataProvider, useNotify } from 'react-admin';import { parse } from 'query-string';




import { useTranslate  } from '../common/language';

import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({  
  largeIconOK: {
    '& svg': {
      fontSize: 100,
      color: '#007E12'
    }
  }
  ,
  largeIconKO: {
    '& svg': {
      fontSize: 200,
      color: '#FF7373'
    }
  }
}));


export const AddMemberValidate = props => {
    
  const translate = useTranslate();  
  const dataProvider = useDataProvider();
  const classes = useStyles();
    
  const [info, setInfo] = useState();
  const [done, setDone] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorApi, setErrorApi] = useState();
  const refresh = useRefresh(); 
  const notify = useNotify();
  const [formSent, setFormSent] = useState();
    
  const { associations_id: associations_id_string, code: code } = parse(props.location.search);
    
  useEffect(() => {
      
    dataProvider.getOne('associations/public', { id: associations_id_string })
    .then(( { data } ) => {   
      setInfo(data);
      
      dataProvider.getOne('users_groups/public/validate_email/' + associations_id_string, { id: code })
      .then(( { data } ) => { 
        setDone(data);    
        setLoading(false);  
      })
      
    })
    .catch(error => {                
      setLoading(false);  
      setError(true);
    });
      
  }, []);
        
  if (loading) return null;
    
  // Mostra confirmació o error de validació
  let message = '';
  if (error)
  {
    message = translate('recercat_centers.validation_email_error');
  }
  else if (done && done.done !== true)
  {
    message = translate('recercat_centers.validation_email_code_'+done.code)
  }
  else
  {
    message =  done.code == 0 ? info.add_member_confirmation : translate('recercat_centers.validation_email_code_'+done.code) 
  }
  
  return (
    <>
      <AddMemberHeader info={info} />
      <Box sx={{ width: '90%', maxWidth: 800, bgcolor: 'background.paper', padding: '20px' }} className="add_member_box" >        
        <Grid container spacing={2}>
          <Grid item xs={12} align="center">  
            <div dangerouslySetInnerHTML={{ __html: message }} />
            <br />
            <br />
          </Grid>
        </Grid>                 
      </Box>
    </>
  );
    
}
